import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'views.JobOfferArticleView.JobOfferArticle.ArticleHeader.category',
    defaultMessage: 'Kategoria:'
  },
  position: {
    id: 'views.JobOfferArticleView.JobOfferArticle.ArticleHeader.position',
    defaultMessage: 'Stanowisko:'
  }
});



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/Article/ArticleHeader/ArticleHeader.intl.js